import React, { useEffect, useState } from "react";

import ButtonV2 from "../components/buttonV2";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { Transition } from "@headlessui/react";

// import Button from "..button";

import { useAppSelector, useMediaQuery } from "../../hooks";
import { FaBars, FaTimes } from "react-icons/fa";

import lispendesLogoWhite from "../../assets/lis-pendens-logo-white.png";
import {
  FACEBOOK,
  INSTAGRAM,
  LINKEDIN,
  LISPENDES_LOGO_ANAMBRA,
  TWITTER,
} from "../../assets";
import { selectToken } from "../../states/slices/authReducer";
import { footer } from "../../constants";

const FooterLinks = ({
  title,
  links,
}: {
  title: string;
  links: Array<{ title: string; link: string }>;
}) => (
  <div className="flex flex-col gap-y-3">
    <span className="text-white font-medium text-[16px]">{title}</span>
    <ul className="flex flex-col gap-y-3">
      {links.map((item) => (
        <span className="text-sm font-medium text-primary-50">
          {item.title}
        </span>
      ))}
    </ul>
  </div>
);
function LandingPageLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { pathname } = location;
  return (
    <div className="overflow-hidden">
      <Header />

      <div
        className={` ${
          pathname === "/faqs" || pathname === "/demo" ? "mt-20" : "mt-28"
        }`}
      >
        {children}
      </div>

      <Footer />
    </div>
  );
}
export default LandingPageLayout;

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const mobile = useMediaQuery("(max-width: 640px)");
  const [open, setOpen] = useState(false);
  const token = useAppSelector(selectToken);
  useEffect(() => {
    const handleScroll = () => {
      const heroHeight =
        document.getElementById("hero-section")?.offsetHeight || 300;
      const scrollY = window.scrollY;
      setScrolled(scrollY > heroHeight - 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const navigate = useNavigate();

  const handleScrollToElem = (id: string) => {
    const elem = document.getElementById(id);
    if (elem) {
      elem.scrollIntoView({ behavior: "smooth" });
    }
  };

  const location = useLocation();
  const { pathname } = location;
  return (
    <>
      {mobile ? (
        <div
          className={`w-full top-0 z-50 flex items-center justify-between px-5 pt-5 pb-7 fixed ${
            scrolled || pathname === "/privacy-policy" || pathname === "/search"
              ? "bg-white shadow-md "
              : open
                ? "bg-black/80"
                : "bg-transparent"
          } transition-colors duration-300 `}
        >
          <Link to={"/"}>
            <img
              src={LISPENDES_LOGO_ANAMBRA}
              className="w-[113.62px] h-[42px]"
              alt=""
            />
          </Link>
          <div onClick={() => setOpen((prev) => !prev)}>
            {open ? (
              <FaTimes
                color={
                  scrolled || pathname === "/privacy-policy" ? "black" : "white"
                }
              />
            ) : (
              <FaBars
                color={
                  scrolled || pathname === "/privacy-policy" ? "black" : "white"
                }
              />
            )}
          </div>
          <Transition
            show={open}
            enter="transform transition-transform ease-out duration-300"
            enterFrom="-translate-y-full"
            enterTo="-translate-y-0"
            leave="transform transition-transform ease-in duration-200"
            leaveFrom="-translate-y-0"
            leaveTo="-translate-y-full"
          >
            <div
              className={`absolute ${
                scrolled || pathname === "/privacy-policy"
                  ? "bg-white"
                  : "bg-black/80"
              } w-full h-[250px] flex items-start flex-col top-20 z-50 shadow-2xl left-0 p-5 gap-y-3`}
            >
              <div
                className={`flex items-start flex-col space-y-5 ${
                  scrolled || pathname === "/privacy-policy"
                    ? "text-black "
                    : "text-white"
                } transition-colors duration-300 font-normal text-[16px]`}
              >
                <span
                  onClick={() => {
                    handleScrollToElem("hero-section");
                    setOpen(false);
                  }}
                  className="cursor-pointer hover:text-globalGold transition-all duration-300"
                >
                  Home
                </span>
                <span
                  onClick={() => {
                    handleScrollToElem("about");
                    setOpen(false);
                  }}
                  className="cursor-pointer hover:text-globalGold transition-all duration-300"
                >
                  About Us
                </span>
                <span
                  onClick={() => {
                    handleScrollToElem("faq");
                    setOpen(false);
                  }}
                  className="cursor-pointer hover:text-globalGold transition-all duration-300"
                >
                  FAQs
                </span>
                <span
                  onClick={() => {
                    handleScrollToElem("contact");
                    setOpen(false);
                  }}
                  className="cursor-pointer hover:text-globalGold transition-all duration-300"
                >
                  Contact
                </span>
              </div>
              <div className="flex items-center gap-x-4 w-full">
                <ButtonV2
                  btnStyle={`w-full p-3  ${
                    scrolled ||
                    (pathname === "/privacy-policy" && "border-globalGold")
                  }  h-fit px-4 py-3 rounded-3xl border border-borderColor flex items-center justify-center`}
                  textStyle={`${
                    scrolled || pathname === "/privacy-policy"
                      ? "text-globalGold"
                      : "text-white"
                  } font-semibold text-[16px]`}
                  title={`Sign in`}
                  handleClick={() => navigate("/sign-in", { replace: true })}
                />

                <ButtonV2
                  btnStyle="w-full h-fit px-4 py-3 rounded-3xl bg-globalGold flex items-center justify-center"
                  textStyle="text-white font-semibold text-[16px]"
                  title="Sign up"
                  handleClick={() => navigate("/sign-up", { replace: true })}
                />
              </div>
            </div>
          </Transition>
        </div>
      ) : (
        <div
          className={`w-full fixed left-0 px-20 py-7  z-50 top-0 right-0 flex items-center justify-between ${
            scrolled || pathname === "/privacy-policy" || pathname === "/search"
              ? "bg-white shadow-md "
              : "bg-transparent"
          } transition-colors duration-300`}
        >
          <Link to={"/"}>
            <img
              src={LISPENDES_LOGO_ANAMBRA}
              className="w-[247px] h-[29px]"
              alt=""
            />
          </Link>
          <div
            className={`flex items-center justify-center space-x-7 ${
              scrolled ||
              pathname === "/privacy-policy" ||
              pathname === "/search"
                ? "text-black "
                : "text-white"
            } transition-colors duration-300 font-normal text-[16px]`}
          >
            <span
              onClick={() => handleScrollToElem("hero-section")}
              className="cursor-pointer hover:text-globalGold transition-all duration-300"
            >
              Home
            </span>
            <span
              onClick={() => handleScrollToElem("about")}
              className="cursor-pointer hover:text-globalGold transition-all duration-300"
            >
              About Us
            </span>
            <span
              onClick={() => handleScrollToElem("faq")}
              className="cursor-pointer hover:text-globalGold transition-all duration-300"
            >
              Faqs
            </span>
            <span
              onClick={() => handleScrollToElem("contact")}
              className="cursor-pointer hover:text-globalGold transition-all duration-300"
            >
              Contact
            </span>
          </div>
          <div className="lg:flex hidden items-center gap-x-4">
            <ButtonV2
              btnStyle={`w-fit px-5 py-3 ${
                scrolled ||
                pathname === "/privacy-policy" ||
                (pathname === "/search" && "border-globalGold")
              } rounded-3xl border border-borderColor flex items-center justify-center`}
              textStyle={`${
                scrolled ||
                pathname === "/privacy-policy" ||
                pathname === "/search"
                  ? "text-globalGold"
                  : "text-white"
              } font-semibold text-[16px]`}
              title={`Login`}
              handleClick={() => navigate("/sign-in", { replace: true })}
            />

            <ButtonV2
              btnStyle="w-fit px-5 py-3 rounded-3xl bg-globalGold flex items-center justify-center"
              textStyle="text-white font-semibold text-[16px]"
              title="Sign up"
              handleClick={() => navigate("/sign-up", { replace: true })}
            />
          </div>
        </div>
      )}
    </>
  );
}

export const Footer = () => {
  return (
    <footer
      id="footer"
      className="w-full lg:p-20 p-5 flex items-center  flex-col bg-[#121212]  gap-y-20 justify-center"
    >
      <div className="w-full flex lg:flex-row flex-col gap-y-10 items-start justify-between">
        <div className="flex flex-col gap-y-4 items-start lg:w-[300px] w-full">
          <img
            src={LISPENDES_LOGO_ANAMBRA}
            className="w-[247px] h-[29px] object-contain "
            alt=""
          />
          <span className="text-primary-50 text-sm font-medium">
            Digitizing property litigation records in Anambra State, empowering
            transparency, trust, and smarter property decisions.
          </span>
        </div>
        <FooterLinks title={footer[0].title} links={footer[0].links} />
        <FooterLinks title={footer[1].title} links={footer[1].links} />

        <div className="flex flex-col lg:items-end items-start gap-y-3">
          <div className="flex items-center gap-x-3">
            <img src={TWITTER} className="w-[24.01px] h-[24.01px]" alt="" />
            <img src={INSTAGRAM} className="w-[24.01px] h-[24.01px]" alt="" />
            <img src={LINKEDIN} className="w-[24.01px] h-[24.01px]" alt="" />
            <img src={FACEBOOK} className="w-[24.01px] h-[24.01px]" alt="" />
          </div>
          <span className="text-primary-50 text-sm font-medium lg:text-end text-start">
            Judiciary Complex, Independence Layout, Anambra, Nigeria.
          </span>
          <a
            href="mailto:support@lispensens.an.gov.ng"
            className="text-primary-50 text-sm font-medium hover:underline"
          >
            support@lispensens.an.gov.ng
          </a>
          <a
            href="tel:+23480949060890"
            className="text-primary-50 text-sm font-medium hover:underline"
          >
            +234 809 4906 0890
          </a>
        </div>
      </div>
      {/* <span>
        © {new Date().getFullYear()} LexScripts AI. All rights reserved.
      </span> */}
    </footer>
  );
};
